export enum SearchType {
  All = 'all',
  Account = 'account',
  Representative = 'advisor',
}
